import { render, staticRenderFns } from "./SourceAudioView.vue?vue&type=template&id=4a059bd4&scoped=true"
import script from "./SourceAudioView.vue?vue&type=script&lang=js"
export * from "./SourceAudioView.vue?vue&type=script&lang=js"
import style0 from "./SourceAudioView.vue?vue&type=style&index=0&id=4a059bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a059bd4",
  null
  
)

export default component.exports